export default "__VITE_ASSET__7a5b2132__"